import React, { useState } from "react";
import { Select, Input, Form, Button } from "antd";
import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import OutPeopleSelect from "../select/outPeopleSelect";
// import api from "../../apis/pc/conversation/conversation";
// import { useSelector } from "react-redux";
const { Option } = Select;
import { getParameterByName } from "@/utils/utils";

const SearchWrapper = styled.div`
  position: absolute;
  right: 33px;
  display: inline-block;
  text-align: right;
  .ant-row.ant-form-item-row{
    margin-bottom: 0;
  }
  .ant-form-inline {
    align-items: center;
  }
  .ant-form-inline .ant-form-item {
    margin-right: 8px;
  }
  .ant-row {
    margin-left: 0;
  }
  .searchInputStyle {
    input {
      height: 22px
    }
  }
  .search-select
  .ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
    border-right: none;
  }
`;

const CovSearch = (props) => {
  // const currentUser = useSelector((state) => state.userInfo.userInfo); // 当前登录用户信息
  const [form] = Form.useForm();
  const [outConnect, setOutConnect] = useState();
  // const [syncNum, setSyncNum] = useState(3); // 同步次数
  const { chatType } = props

  const getOutConnect = (value) => {
    if (value) {
      setOutConnect(JSON.parse(value.value));
    } else {
      setOutConnect({});
    }
  };
  const getValue = () => {
    let value = form.getFieldsValue();
    value.extendUserId = outConnect ? outConnect.id : "";
    if(outConnect?.extendUserType) {
      value.extendUserType = outConnect.extendUserType;
    }
    props.handleSearch({ ...value, selectFlag: value.content || value.extendUserId ? false : true, extendUserType: value?.extendUserType });
  };
  // const getSyncNumber = () => {
  //   api.getSyncNum().then(({ code, data }) => {
  //     if (code === 0) {
  //       setSyncNum(3 - data.count);
  //     }
  //   });
  // };
  // const confirm = () => {
  //   api.messageSync().then((res) => {
  //     if (res.code === 0) {
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 500);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   getSyncNumber();
  // }, []);

  return (
    <SearchWrapper
      style={
        getParameterByName("deviceType") === "iframe"
          ? {
            width: "auto",
            right: "77px",
            top: "12px",
          }
          : {}
      }
    >
      <Form form={form} layout={"inline"}>
        {getParameterByName("deviceType") === "iframe" ? (
          ""
        ) : (
          <Form.Item name={"extendUserId"}>
            <OutPeopleSelect
              style={{ width: 240 }}
              getOutConnect={getOutConnect}
              chatType={chatType}
            />
          </Form.Item>
        )}
        {/* <Form.Item
          name={"scope"}
          className={"search-select"}
          style={{ marginRight: 0 }}
          initialValue={1}
        >
          <Select style={{ width: 120, textAlign: "left" }}>
            <Option value={1}>搜会话</Option>
            <Option value={2}>搜群聊</Option>
          </Select>
        </Form.Item> */}
        {/* <Form.Item name={"content"}>
          <Input
            placeholder={"搜索聊天记录"}
            style={{ width: 240 }}
            autoComplete={"false"}
            allowClear={true}
            className="searchInputStyle"
          />
        </Form.Item>
        <Button icon={<SearchOutlined />} onClick={() => getValue()}>
          搜索
        </Button> */}
        {/* {getParameterByName("deviceType") === "iframe"
          ? ""
          : currentUser.isRoleAdmin && (
            <Popconfirm
              title={
                syncNum !== 0
                  ? `数据从企业微信后台同步，今日还有${syncNum}次机会`
                  : "您今天的同步次数已达上限，请明天再试"
              }
              onConfirm={confirm}
              onCancel={() => { }}
              icon={false}
              overlayClassName="firm"
              placement="bottomRight"
              okText="同步"
              cancelText="取消"
            >
              <Button icon={<SyncOutlined />} style={{ marginLeft: 5 }}>
                同步
              </Button>
            </Popconfirm>
          )} */}
      </Form>
    </SearchWrapper>
  );
};

export default CovSearch;